import {
    DataTable,
    DateField,
    ExportButton,
    List,
    ReferenceField,
    SearchInput,
    TextField,
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { useRecordContext } from 'ra-core';
import { TopToolbar } from '../../layout/TopToolbar';
import { PermissionCreateButton } from '../shared/PermissionCreateButton';
import { StatusBadge } from '../shared/StatusBadge';

const SalesOrderFilters = [
    <SearchInput key="q" source="reference@ilike" alwaysOn />,
];

const SalesOrderListActions = () => (
    <TopToolbar>
        <ExportButton />
        <PermissionCreateButton permission="manage_documents" label="New SO" />
    </TopToolbar>
);

const StatusCell = () => {
    const record = useRecordContext();
    if (!record || !record.status) return null;
    return <StatusBadge status={record.status} />;
};

const AmountCell = () => {
    const record = useRecordContext();
    if (!record?.total_amount) return <span className="text-slate-400 text-xs">—</span>;
    return (
        <div className="flex items-center gap-1 font-bold text-green-700">
            {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(record.total_amount)}
        </div>
    );
};

export const SalesOrderList = () => (
    <List 
        filters={SalesOrderFilters} 
        actions={<SalesOrderListActions />}
        sort={{ field: 'created_at', order: 'DESC' }}
        perPage={25}
        title="Sales Orders"
        className="p-6"
        filtersLayout="two-rows"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="show">
                <DataTable.Col
                    source="reference"
                    label="Sales Order No."
                    className="font-mono font-bold text-slate-900"
                />
                <DataTable.Col label="Date">
                    <DateField source="date" />
                </DataTable.Col>
                <DataTable.Col label="Customer">
                    <ReferenceField source="company_id" reference="companies" link={false}>
                        <TextField source="name" className="font-semibold text-blue-600" />
                    </ReferenceField>
                </DataTable.Col>
                <DataTable.Col label="Project">
                    <ReferenceField source="project_id" reference="projects" link={false}>
                        <TextField source="name" className="text-sm" />
                    </ReferenceField>
                </DataTable.Col>
                <DataTable.Col label="Total">
                    <AmountCell />
                </DataTable.Col>
                <DataTable.Col label="Status">
                    <StatusCell />
                </DataTable.Col>
                <DataTable.Col label="Created">
                    <DateField source="created_at" showTime showDate />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
